import axios from 'axios';

export const TOKEN_KEY = 'ling.admin.token';
export const api = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL || '', timeout: 30000 });

/** Open the public reader for a persisted chart. The admin app is served on
 * 3020 in development while the reader is served by the API/static server on
 * 3017. Production deployments can override this with VITE_READER_BASE_URL.
 */
export function openReadingReport(readingId?: number | null): void {
  if (!readingId) return;
  const configured = import.meta.env.VITE_READER_BASE_URL;
  const base = configured || `${window.location.protocol}//${window.location.hostname}:3017`;
  const url = `${base.replace(/\/$/, '')}/report.html?reading=${encodeURIComponent(String(readingId))}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(undefined, (error) => {
  if (error.response?.status === 401) {
    sessionStorage.removeItem(TOKEN_KEY);
    window.dispatchEvent(new Event('ling:auth-required'));
  }
  return Promise.reject(error);
});

export function messageOf(error: unknown): string {
  if (axios.isAxiosError(error)) return error.response?.data?.error || error.message;
  return error instanceof Error ? error.message : '请求失败';
}
